module.exports = __webpack_public_path__ + "static/img/footer_icon_00_zh.9d50708.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer_icon_00_zh.png
// module id = 2PDq
// module chunks = 34